<template lang="html">
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color':currentIntegration.color.main}">
        <div slot="title">
            <h2>Add new</h2>
        </div>

        <div slot="body">
            <!-- Top area -->
            <top-area :integration="currentIntegration" >
                <div class="bg-blue-pale p-2 mt-3">
                    Note: This integration is only available for OTAs that adopt the OCTO standard. 
                </div>
            </top-area>

            <div class="px-5 pb-4">
                <div class="octo-integrate__otas row py-3">
                    <!-- New OCTO Integration area -->
                    <div class="col-12 py-5">
                        <div class="d-flex align-items-center w-100">
                            <div class="octo-integrate__step-number d-flex border-dark align-items-center justify-content-center">1</div>
                            <div class="octo-integrate__step-text flex-grow-1">
                                To add a new OTA, you will need to provide the name and email of the OTA. Once submitted, the integration keys will be provided.
                            </div>
                            <button type="button" class="btn green octo-integrate__step-button" @click="openIntegration(currentIntegration)">
                                Add New
                            </button>
                        </div>
                    </div>

                    <!-- OCTO Integrations list -->
                    <div class="octo-integrate__otas-list col-12 my-3">
                        <div v-if="getIsLoadingSupplierIntegrations" class="d-flex flex-column justify-content-center align-items-center p-4 h-100">
                            <span class="bold fs-large">Loading</span>
                            <loader></loader>
                        </div>
                        <div v-else>
                            <list class="" :header="header" :body="body" :rows="getOctoIntegrations" :actions="actions"></list>
                        </div>
                    </div>
                </div>
                
                <bottom-area
                    :loadingConnectBtn="isOctoConnecting"
                    @close="closeModal()"
                />
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { required, minLength } from "vuelidate/lib/validators"

    import Modal from '@/tools/modal/Modal'
    import List from '@/tools/list/baseList'
    import loader from '@/tools/loaders/loader1'
    import topArea from './popupParts/topArea'
    import bottomArea from './popupParts/bottomArea'

    export default {
        data() {
            return {
                header: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: {
                        ota: 'OTA',
                        status: 'Status',
                    },
                },
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        ota: this.formatOTAName,
                        status: this.formatStatus,
                    },
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'settings',
                            title: 'Settings',
                            tooltip: 'Settings',
                            params: '',
                            class: '',
                            icon: 'fas fa-cog fs-large',
                            event: this.openSettings,
                        }
                    ],
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSingleIntegration',
                'getIsOctoConnecting',
                'getIsLoadingSupplierIntegrations',
                'getAllIntegrations',
                'getIntegrationStatus'
            ]),
            getOctoIntegrations() {
                return this.getAllIntegrations.filter(i => i.integration === 210);
            },
            currentIntegration() {
                return this.getSingleIntegration(205);
            },
            isOctoConnecting() {
                return this.getIsOctoConnecting;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createOctoIntegration',
                'downloadSupplierIntegrations',
                'downloadAgents',
                'setIntegration',
                'openModal',
                'openIntegrationSettings'
            ]),
            openSettings(item) {
                if (item.integrationStatus !== 1) {
                    this.$dialog.alert(
                        '<h2 class="mb-3">Integration Settings</h2>\
                        <div class="mt-4">Please connect this integration <strong>first</strong> to access its settings.</div>',
                        { okText: 'Ok' }
                    )

                    return;
                } 

                this.openIntegrationSettings(item);
            },
            view(item) {
                this.setIntegration(item);
                this.openModal('octoIntegrations');
            },
            openIntegration(integration) {
                this.setIntegration(integration);
                this.openModal('createOctoIntegration');
            },
            formatOTAName(item) {
                return item.name;
            },
            formatStatus(item) {
                const status = this.getIntegrationStatus(item.integrationStatus);

                return `<span class="${status.backgroundColor} bold fs-small">${status.label}</span>`;
            },
            close() {
                this.closeModal();
            }
        },
        components: {
            topArea,
            bottomArea,
            Modal,
            loader,
            List
        }
    }
</script>

<style lang="scss" scoped>
    .octo-integrate__otas {
        min-height: 110px;

        &-list {
            height: 30vh;
            overflow: auto;
        }
    }

    .octo-integrate__step-number {
        font-size: 1rem;
        border-radius: 9999px;
        width: 1.875rem;
        max-width: 1.875rem;
        min-width: 1.875rem;
        text-align: center;
        height: 1.875rem;
        font-weight: bold;
        margin-right: 1em;
    }
    
    .octo-integrate__step-text {
        text-align: left;
        align-self: center;
        margin-right: 1.5rem;
        min-width: 0;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .octo-integrate__step-button {
        align-self: center;
        min-width: 7.5rem;
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// octoIntegrate.vue?81d3bf08